export default {
  name: "Shivam Kaushik",
  email: "shivam.kaushik73@gmail.com",

  githubLink: "https://github.com/mythrex",
  linkedinLink: "https://www.linkedin.com/in/shivamkaushik73/",
  twitterLink: "https://twitter.com/shivamkaushik73",
};
